export const transferPointsKeys = {
  all: ['all', 'transferPoints'] as const,
  getTransferPointsProfiles: (params: string[]) => [...transferPointsKeys.all, 'getTransferPointsProfiles', ...params],
  postTransferPoints: () => [...transferPointsKeys.all, 'postTransferPoints'],
}
